import axios from 'axios'
import dayjs from 'dayjs'
import { useNavigate, useLocation } from 'react-router-dom'
import _ from 'lodash'
import {v4 as uuidv4} from 'uuid'

export function round(num, decimals) {
  return Math.round((num + Number.EPSILON) * 10 ** decimals) / 10 ** decimals
}
export function withRouter(Component) {
  return props => <Component {...props} navigate={useNavigate()} location={useLocation()} />
}

export function isIE(nav){
  return /MSIE\s([\d.]+)/.test(nav.userAgent) ||// eslint-disable-next-line
         ((nav.appName === 'Netscape') && (navigator.userAgent.indexOf("Trident") !== -1))
}

export function isSecure(password) {
  //const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/  
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+,.(){}<>?/:;'"~`\[\]\\\|-])(?=.{8,})/;
  return !!password.match(regex)
}

export function isEmpty(obj){
  return !obj || Object.keys(obj).length === 0
}

export function setAuthorisationHeader(token = null){
  if (token) {
    axios.defaults.headers.common.authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.authorization;
  }
}

export function setAdvisorClientHeader(id = null){
  if (id) {
    axios.defaults.headers.common.activeID = id;
  } else {
    delete axios.defaults.headers.common.activeID;
  }
}

export function removeCommas(num) {
  if (typeof num !== 'string') return 0// eslint-disable-next-line
  num = num.replace(/[^\d\.]/g, '')
  if (num ==='') return num
  return parseFloat(num)
}

export function removeCommasAllowNeg(num) {
  if (typeof num !== 'string') return 0// eslint-disable-next-line
  num = num.replace(/[^\-\d\.]/g, '')
  if (num === '-' || num ==='') return num
  return parseFloat(num)
}

export function formatRate(numToFormat, digits = 0, noNeg = false) {
  if (numToFormat==='') return ''
  if (!numToFormat || numToFormat === 0) {
    return (0).toFixed(digits) + '%'
  }
  if (numToFormat === '-') {
    return numToFormat
  }
  const result = Math.abs(numToFormat).toFixed(digits).replace(/./g, function(c, i, a) {
    return i > 0 && c !== '.' && (a.length - i) % 3 === 0 ? ',' + c : c
  })
  if (!noNeg && numToFormat < 0) {
    return '-' + result + '%'
  }
  return result + '%'
}

export function formatCurrency(numToFormat, digits = 0, symb = '$', noNeg = false) {
  if (numToFormat==='') return ''
  if (!numToFormat || numToFormat === 0) {
    return symb + (0).toFixed(digits)
  }
  if (numToFormat === '-') {
    return numToFormat
  }
  if (!noNeg && numToFormat < 0) {
    symb = '-' + symb
  }
  return symb + Math.abs(numToFormat).toFixed(digits).replace(/./g, function(c, i, a) {
    return i > 0 && c !== '.' && (a.length - i) % 3 === 0 ? ',' + c : c
  })
}

export function removePhoneFormat(num) {
  if (typeof num !== 'string') return ''
  num = num.replace(/[^\d+]+/g, '')
  if (num ==='') return num
  return num
}

export function formatPhoneNumber(input) {
  if (!input) return ''
  let output = ''
  input.replace( /^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/, function( match, g1, g2, g3 )
      {
        if ( g1.length ) {
          output += g1 
          if ( g1.length === 3 ) {
              output += "-" 
              if ( g2.length ) {
                  output += g2  
                  if ( g2.length === 3 ) {
                      output += "-" 
                      if ( g3.length ) {
                          output += g3 
                      }
                  }
              }
           }
        }
      }       
    )        
  return output
}

export function getAttibuteValue(e, attribute){
  if(e && e.target.attributes && e.target.attributes[attribute]){
    return e.target.attributes[attribute].value
  }else{
    return null
  }
}

export function getCustomAttribute(e, attribute){
  if(e && e.attributes && e.attributes[attribute]){
    return e.attributes[attribute].value
  }else{
    return null
  }
}

export function getItemIdFromRow(e){
  return e.target.attributes._id.value
}

export function getItemByIdFrom(id, array) {
  return array.find(v => v.id === id)
}

export function getLinkedToName(id, linked){
  for (let item of linked) {
    if(item.id === id) return item.description
  }
  return "Unlinked"
}

export function handleFileDownload(res, exportName){  
  if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(res, exportName);
  } else {
      var blobURL = window.URL.createObjectURL(res);
      var fileLink = document.createElement('a')
      fileLink.style.display = 'none'
      fileLink.href = blobURL          
      fileLink.setAttribute('download', exportName)
      document.body.appendChild(fileLink)
      fileLink.click()
      fileLink.remove()
      window.URL.revokeObjectURL(blobURL)
    /* } */
  }
}

export function isThisYear(data){
  return Object.keys(data).includes('planID') && data.planID === '00000000-0000-0000-0000-000000000000'
}

export function getWizardDesc(owner, primary, partner, type) {
  let desc = ''
  if (type!=='RESP') {
    switch (owner) {
      case 'p': 
        desc = primary
        break
      case 's': 
        desc = partner
        break
      default: desc = 'Joint'
    }
    desc += ' '
  }
  desc += type
  return desc
}

export function getEndDayOfIn(month, year){
  return new Date(year, month + 1, 0).getDate()
}

export function locationToArray(location) {
  return location.split('/')
}

export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function calcOffset(value, min, max) {
  if (value<min) { value = min }
  const ratio = (value - min) / (max - min);
  return ratio * 100
}

export function getTotalThisYearValue(items, propName = 'estimated') {
  let total = 0
  for (let v of items) {
    total += v[propName]
  }
  return total
}

// todo add functionality of one person
export function mapUserNumberToName(number, users){
  if(number === 1){
    return users.primary.name
  }else if(number === 0){
    return users.partner.name
  }else{
    return 'Joint'
  }
}

export function getMaxLongevity({ partnerLifeExpectancy, primaryLifeExpectancy}){
  if(partnerLifeExpectancy){
    return primaryLifeExpectancy > partnerLifeExpectancy ? primaryLifeExpectancy : partnerLifeExpectancy
  }else{
    return primaryLifeExpectancy
  }
}

export function getMinLongevity({ partnerLifeExpectancy, primaryLifeExpectancy}){
  if(partnerLifeExpectancy){
    return primaryLifeExpectancy > partnerLifeExpectancy ? partnerLifeExpectancy : primaryLifeExpectancy
  }else{
    return primaryLifeExpectancy
  }
}

export function getLongevityByAllocation({ partnerLifeExpectancy, primaryLifeExpectancy }, allocation){
  if(partnerLifeExpectancy){
    switch (allocation) {
      case 1:
      case '1':
        return primaryLifeExpectancy
      case 0:
      case '0':
        return partnerLifeExpectancy
      default:
        return getMaxLongevity({partnerLifeExpectancy, primaryLifeExpectancy})
    }
  }else{
    return primaryLifeExpectancy
  }
}

export function getUserAgeByAllocation(users, allocation) {
  switch (allocation) {
    case 1:
      return users.primary.age
    case 0:
      return users.partner.age
    default:
      if(Object.keys(users).includes('partner')){
        return users.primary.age > users.partner.age ? users.partner.age : users.primary.age
      }else{
        return users.primary.age
      }
  }
}

export const getBirthYears = (users, allocation) => {
  if(!users) return 
  switch (allocation) {
    case 1:
      return {primary: dayjs(users.primary.dateOfBirth, 'YYYY/MM/DD').year()}
    case 0:
      return {partner: dayjs(users.partner.dateOfBirth, 'YYYY/MM/DD').year()}
    default:
      if(users.partner){
        return {
          primary: dayjs(users.primary.dateOfBirth, 'YYYY/MM/DD').year(),
          partner: dayjs(users.partner.dateOfBirth, 'YYYY/MM/DD').year()
        }
      }else{
        return {primary: dayjs(users.primary.dateOfBirth, 'YYYY/MM/DD').year()}
      }
  }
}

export const getYearAges = (year, births, event = false) => {
  if(births){
    if(Object.keys(births).length === 2){
      return `${event?'Dec 31, ':''}${year} (${year>births.primary ? year-births.primary : '-'}/${year>births.partner ? year-births.partner : '-'})`
    }else{
      if(births.primary){
        return `${event?'Dec 31, ':''}${year} (${year>births.primary ? year-births.primary : '-'})`
      }else if(births.partner){
        return `${event?'Dec 31, ':''}${year} (${year>births.partner ? year-births.partner : '-'})`
      }else{
        return `${event?'Dec 31, ':''}${year}`
      }
    }
  }else{
    return `${event?'Dec 31, ':''}${year}`
  }
}

export function mapItemTypeName(itemtype, types){
  for(let { value,text } of types){
    if(value === itemtype){
      return text
    }
  }
  return 'Unknown'
}

export function isEmployerContributions(type) {
  return ['reg-grsp', 'reg-dpsp', 'reg-dcpp'].includes(type)
}

export function getAnnualMultiplier(freq){
  switch (freq) {
    case 'annually':
      return 1
    case 'monthly':
      return 12
    case 'weekly':
      return 52
    case 'bi-weekly':
      return 26
    case 'semi-monthly':
      return 24
    default:
      return 1
  }
}

export function getDisplayFrequency(freq) {
  switch (freq) {
    case 'weekly':
      return 'Weekly'
    case 'bi-weekly':
      return 'Bi-Weekly' 
    case 'semi-monthly':
      return 'Semi-Monthly' 
    case 'monthly':
      return 'Monthly'
    case 'quarterly':
      return 'Quarterly'
    case 'annually':
      return 'Annually'
    default:
    return 'Unknown'
  }
}

export function getValuesByFrequency(paymentFrequency, itemType) {
  let values = {}
  switch (paymentFrequency) {
    case 'annually':
      values = {
        cf: 1,
        ppy: 1,
        dpf: 365
      }
      break
    case 'monthly':
      values = {
        cf: 12,
        ppy: 12,
        dpf: 30
      }
      break
    case 'weekly':
      values = {
        cf: 52,
        ppy: 52,
        dpf: 7
      }
      break
    case 'bi-weekly':
      values = {
        cf: 26,
        ppy: 26,
        dpf: 14
      }
      break
    case 'semi-monthly':
      values = {
        cf: 24,
        ppy: 24,
        dpf: 15
      }
      break
    default:
      return 
  }  
  if (itemType === 'mortgage') {
    values.cf = 2;
  }
  return values
}

export function getDebtStart({balanceAsOf, linkedToObj}) {
  const bao = dayjs(balanceAsOf, 'YYYY/MM/DD')
  
  if(!isEmpty(linkedToObj) && linkedToObj.bars.length > 0 && (bao < dayjs(linkedToObj.bars[0].startDate))){
    return dayjs(linkedToObj.bars[0].startDate)
  }else{
    return bao
  }
}

export function calcAmort(data) {
  const startDate = getDebtStart(data)
  const endDate =  dayjs(data.baseEndDate, 'YYYY/MM/DD')
  let months = endDate.month() - startDate.month() + (12 * (endDate.year() - startDate.year()))
  let payments_year = Math.floor(months / 12); 
  return payments_year
}

export function calcPayment(data) {
  if (data.itemType === 'reverse') { return 0 } 
  if (data.itemType === 'int_only') {
    if (!data.minOnly) {
      let minPayment = (data.balance * data.growthRate / 12)
      return (data.payment < minPayment) ? minPayment : data.payment      
    }
    return 0      
  }

  const startDate = getDebtStart(data)
  const endDate =  dayjs(data.baseEndDate, 'YYYY/MM/DD')
  let months = endDate.month() - startDate.month() + (12 * (endDate.year() - startDate.year()))
  if (months <=0) { return 0 }
  
  let pRate, pvFactor
  let { cf, ppy } = getValuesByFrequency(data.paymentFrequency, data.itemType)  
  if (data.itemType === 'mortgage') {
    let AER = Math.pow((1 + data.growthRate / cf), cf) - 1;
    pRate = -1 + Math.pow((1 + AER), 1 / ppy);
  } else {
    pRate = data.growthRate / cf
  }

  if (!pRate) {
    pvFactor = months
  } else {      
    pvFactor = (1 - (Math.pow((1 + pRate), -months))) / pRate
    if (isNaN(pvFactor)) {
      if(ppy >= 12){
        pvFactor = (months / 12) * ppy
      } else if (months>12) {
        pvFactor = Math.floor(months/12)
      } else {
        pvFactor = 1
      }
    }
  }
  
  if (!pvFactor) {
    return data.balance
  } else {
    return Math.ceil(data.balance / pvFactor)
  }
}

export function getBarIdByYear(year, bars){
  for (var key in bars) {
    let bar = bars[key]
    if (!bar.converted) {
      const startYear = dayjs(bar.startDate, 'YYYY/MM/DD').year()
      const endYear = dayjs(bar.endDate, 'YYYY/MM/DD').year()
      if(startYear <= year && year <= endYear){
        return key
      }
    }
  }
  return 
}

export function isProperty(type){
  const itemTypes = ['personal', 'investment', 'vehicle', 'other']
  return itemTypes.includes(type)
}

export function renderSurvivorBar(type){
  if (type.includes('reg')) { return true }
  const itemTypes = ['open', 'tfsa', 'resp', 'cpp', 'dbpi']
  return itemTypes.includes(type)
}

export function addUpdateBar(bars, bar, allowNeg, debt){
  if (!bar) return bars
  // Maybe add if !allowNeg && bar.value < 0 return bars

  let newS = dayjs(bar.startDate, 'YYYY/MM/DD').year()
  let newE = dayjs(bar.endDate, 'YYYY/MM/DD').year()

  if(!bar.id) { bar.id = uuidv4() }

  const delKeys = []

  // Check Against Converted Bar
  // Postive Values Outside Converted for all but DEBT
  // Negatives allowed anywhere except (LIRA/LIF/DCPP)
  if (bar.value > 0 && !debt) {
    for (var key in bars) {
      if (key !== bar.id) {
        const curBar = bars[key]
        if (curBar.converted) {
          const curS = dayjs(curBar.startDate, 'YYYY/MM/DD').year()

          if ( curS <= newS ){
            //no bars after converted start
            return bars
          }else if (newS < curS && curS <= newE) {
            //no bars can end after converted start
            newE = curS-1
            bar.endDate = `${curS - 1}/12/31`
            //return bars
          } 
        }
      }
    } 
  } else if ((bar.value < 0 && allowNeg === -1) || (bar.value > 0 && debt && allowNeg !== 1)) { // Maybe change this and have the converted bar extend on withdrawal
    //Restricted to inside the converted bar (LIRA/LIF/DCPP/DEBT)
    let conStart = 9999
    let conEnd = 0
    for (var key in bars) {
      if (key !== bar.id) {
        const curBar = bars[key]
        if (curBar.converted || curBar.survivorBar) {
          const curS = dayjs(curBar.startDate, 'YYYY/MM/DD').year()
          const curE = dayjs(curBar.endDate, 'YYYY/MM/DD').year()
          if (curS < conStart) { conStart = curS }
          if (curE > conEnd) { conEnd = curE }
        }
      }
    }
    if (newS >= conStart && newS <= conEnd && newE > conEnd) {
      bar.endDate = `${conEnd}/12/31`
      //return bars
    } else if (newE >= conStart && newE <= conEnd && newS < conStart) {
      bar.startDate = `${conStart}/01/01`
      //return bars
    } else {
    if (newS < conStart ) { 
        newS=conStart
        bar.startDate = `${conStart}/01/01` 
      } else if (newS > conEnd ) { 
        newS=conEnd
        bar.startDate = `${conEnd}/01/01` 
      }
      if (newE > conEnd ) { 
        newE=conEnd
        bar.endDate = `${conEnd}/12/31` 
      } else if (newE < conStart ) { 
        newE=conStart
        bar.endDate = `${conStart}/12/31` 
      }
    }
  } 
  
  //Check For Overlap and Splitting
  for (var key in bars) {
    if (key !== bar.id) {
      const curBar = bars[key]
      if (!curBar.converted && !curBar.survivorBar) {
        const curS = dayjs(curBar.startDate, 'YYYY/MM/DD').year()
        const curE = dayjs(curBar.endDate, 'YYYY/MM/DD').year()

        if(curE <= newE){
          if(curS < newS && newS <= curE){
            //move end of old bar
            curBar.endDate = `${newS - 1}/12/31`
          }else if (newS <= curS && curS <= newE) {
            //delete old        
            delKeys.push(key)
          }
        }else{
          if(newS <= curS && curS <= newE){
            //move start of old bar
            curBar.startDate = `${newE + 1}/01/01`
          }else if (curS < newS) {
            //split in 3
            let _tmp = Object.assign({}, curBar)
            curBar.endDate = `${newS - 1}/12/31`
            _tmp.startDate = `${newE + 1}/01/01`
            _tmp.id = uuidv4()
            _tmp.planID = bar.planID
            bars[_tmp.id] = _tmp
          } 
        }//end logic
      }
    }    
  }

  bars[bar.id] = bar
  for (let key of delKeys) {
    delete bars[key]
  }
  return bars 
}

export function getBarByYear(year, bars){
  console.log("BAR WARNING!")
  for (let i = 0, l = bars.length; i<l; i++) {
    if (!bars[i].converted) {
      const startYear = dayjs(bars[i].startDate, 'YYYY/MM/DD').year()
      const endYear = dayjs(bars[i].endDate, 'YYYY/MM/DD').year()
      // const startYear = moment(bars[i].startDate).format('YYYY/MM/DD').year()
      // const endYear = moment(bars[i].endDate).format('YYYY/MM/DD').year()
      if(startYear <= year && year <= endYear){
        return bars[i]
      }
    }
  }
  return 
}

export function handleAmountChangeFreq(ltActivity, amount, update = 1) {
  if (!ltActivity) return

  let details = JSON.parse(ltActivity)
  if (details.length > 0) {
    if (update===0) { // Reset  
      ltActivity = JSON.stringify(details.fill(amount, 0))  
    } else if (update === 1) { // Future  
      const past = getPastIndex(details.length)
      ltActivity = JSON.stringify(details.fill(amount, past))
    }
  }
  return JSON.stringify(details)
}

export function handleAmountChangeAnnual(ltActivity, amount) {
  if (!ltActivity) return

  let details = JSON.parse(ltActivity)
  const nonZeroCheck = details.filter(i=>i!==0)
  if (nonZeroCheck.length === 1) {
    const i = details.findIndex( x => x!==0)
    details[i] = amount
  } else {
    const sum = getArraySum(details)
    let diff = amount-sum 
    if (diff>0) {
      details[details.length-1] += diff
    } else if (diff<0) {
      diff *= -1
      for (let i = details.length-1; i >= 0; --i){
        if (details[i] >= diff) { 
          details[i] -= diff 
          break
        } else { // details < diff
          diff -= details[i]
          details[i] = 0              
        }
      }
    }
  }
  return JSON.stringify(details)
}

export function getArraySum(details){
  let data = Array.isArray(details) ? details : JSON.parse(details)
  let sum = 0
  for (let i = 0; i < data.length; ++i) {
    if(!!data[i]) { sum += data[i]}    
  }
  return sum
}
export function getPastSum(details){
  let data = Array.isArray(details) ? details : JSON.parse(details)
  let sum = 0
  const past = getPastIndex(data.length)
  for (let i = 0; i < past; ++i) {
    if(!!data[i]) { sum += data[i]}    
  }
  return sum
}
export function getPastIndex(length) {
  return getIndexByDate(new Date(), length)
}
export function getIndexByDate(now, length) {
  let past = 0
  switch (length) {
    case 52:
      past = Math.floor((now - new Date(now.getFullYear(), 0, 1)) / 604800000 )
      break
    case 26:
      past = Math.floor((now - new Date(now.getFullYear(), 0, 1)) / 604800000)
      past = Math.floor(past/2) 
      break
    case 24:
      past = now.getMonth() * 2
      if (now.getDate()>14) { past+=1 }
      break
    default:
      past = now.getMonth()
  } 
  return past
}

export const sorting = {
  futurechoices:{
    savings: {
      sortByAllocation: data => _.sortBy(data, ['allocation', 'itemType', el=>byIgnoreCaseDescription(el)]),
      sortByItemType: data => _.sortBy(data, ['itemType', 'allocation', el=>byIgnoreCaseDescription(el)]),
      sortByDescription: data => _.sortBy(data, [el=>byIgnoreCaseDescription(el), 'allocation', 'itemType']),
      sortByDescriptionDes: data => _.orderBy(data, [el=>byIgnoreCaseDescription(el), 'allocation', 'itemType'], ['desc', 'asc', 'asc']),
    },
    properties: {
      sortByAllocation: data => _.sortBy(data, ['allocation', 'itemType', el=>byStartDate(el), el=>byIgnoreCaseDescription(el)]),
      sortByItemType: data => _.sortBy(data, ['itemType', el=>byStartDate(el), 'allocation', el=>byIgnoreCaseDescription(el)]),
      sortByDescription: data => _.sortBy(data, [el=>byIgnoreCaseDescription(el), 'itemType', el=>byStartDate(el), 'allocation']),
      sortByDescriptionDes: data => _.orderBy(data, [el=>byIgnoreCaseDescription(el), 'itemType', el=>byStartDate(el), 'allocation'], ['desc', 'asc', 'asc', 'asc']),
      sortBySliderStartDate: data => _.sortBy(data, [el=>byStartDate(el), 'itemType', 'allocation', el=>byIgnoreCaseDescription(el)])
    },
    cashflow: {
      sortByAllocation: data => _.sortBy(data, ['allocation', el=>byStartDate(el), 'itemType', el=>byIgnoreCaseDescription(el)]),
      sortByItemType: data => _.sortBy(data, ['itemType', el=>byStartDate(el), 'allocation', el=>byIgnoreCaseDescription(el)]),
      sortByDescription: data => _.sortBy(data, [el=>byIgnoreCaseDescription(el), el=>byStartDate(el), 'allocation', 'itemType']),
      sortByDescriptionDes: data => _.orderBy(data, [el=>byIgnoreCaseDescription(el), el=>byStartDate(el), 'allocation', 'itemType'], ['desc', 'asc', 'asc', 'asc']),
      sortBySliderStartDate: data => _.sortBy(data, [el=>byStartDate(el), 'allocation', 'itemType', el=>byIgnoreCaseDescription(el)])
    },
    activities: {
      sortByDescription: data => _.sortBy(data, [el=>byIgnoreCaseDescription(el), el=>byStartDate(el), el=>byEndDate(el)]),
      sortByDescriptionDes: data => _.orderBy(data, [el=>byIgnoreCaseDescription(el), el=>byStartDate(el), el=>byEndDate(el)], ['desc', 'asc', 'asc']),
      sortBySliderStartDate: data => _.sortBy(data, [el=>byStartDate(el), el=>byIgnoreCaseDescription(el), el=>byEndDate(el)]),
      sortBySliderEndDate: data => _.sortBy(data, [el=>byEndDate(el), el=>byIgnoreCaseDescription(el), el=>byStartDate(el)])
    }
  },
}

export function sortByDescription(a,b) {
  let comparison = 0
  if(a.description.toLowerCase() > b.description.toLowerCase()){
    comparison = 1
  }else if (a.description.toLowerCase() < b.description.toLowerCase()) {
    comparison = -1
  }
  return comparison
}

export function sortByDescriptionDes(a,b) {
  let comparison = 0
  if(a.description.toLowerCase() > b.description.toLowerCase()){
    comparison = -1
  }else if (a.description.toLowerCase() < b.description.toLowerCase()) {
    comparison = 1
  }
  return comparison
}

export function sortByItemType(a,b) {
  let comparison = 0
  if(a.itemType > b.itemType){
    comparison = 1
  }else if (a.itemType < b.itemType) {
    comparison = -1
  }
  return comparison
}

export function sortByAllocation(a,b) {
  let comparison = 0
  if(a.allocation === 1 &&  b.allocation === 0){
    comparison = -1
  }else if (a.allocation === 0 &&  b.allocation === 1) {
    comparison = 1
  }else if(a.allocation > 0 && a.allocation < 1){
    comparison = 1
  }else if(b.allocation > 0 && b.allocation < 1){
    comparison = -1
  }
  return comparison
}

export function sortByEstimatedValue(a,b) {
  return a.estimatedValue - b.estimatedValue
}

export function sortByEstimatedBalance(a,b) {
  return a.estimatedBalance - b.estimatedBalance
}

export function sortByContributions(a,b) {
  return a.monthlyContributions - b.monthlyContributions
}

export function sortByAnnualIncome(a,b) {
  return a.annualIncome - b.annualIncome
}

export function sortByMonthlyAmount(a,b) {
  return a.monthlyAmount - b.monthlyAmount
}

export function sortByAnnualAmount(a,b) {
  return a.annualAmount - b.annualAmount
}

export function sortBySliderStartDate(a,b) {
  let comparison = 0
  if(!a.bars[0] || !b.bars[0]) return comparison

  if(dayjs(new Date(a.bars[0].startDate)).isBefore(new Date(b.bars[0].startDate))){
    comparison = -1
  }else if (dayjs(new Date(b.bars[0].startDate)).isBefore(new Date(a.bars[0].startDate))) {
    comparison = 1
  }
  return comparison
}

function byIgnoreCaseDescription(el){
  return el.description.toLowerCase()
}

function byStartDate(el){
  if(el.bars[0]){
    return el.bars[0].startDate
  }else{
    return 0
  }
}

function byEndDate(el){
  console.log("BAR WARNING!")
  if(el.bars[el.bars.length - 1]){
    return el.bars[el.bars.length - 1].endDate
  }else{
    return 0
  }
}
